import React, { useState } from "react";
import { MdOutlineSettingsApplications } from "react-icons/md";
import "./CardFase.css";

import ModalConfigPrimeraFase from "../../Modals/ModalConfigPrimeraFase/ModalConfigPrimeraFase";


const CardFaseIndividual = () => {
    const [openConfigPrimeraFase, setOpenConfigPrimeraFase] = useState(false);

    const handleOpenConfig = (idtypephase) => {

        if (idtypephase) setOpenConfigPrimeraFase(true)
    };
    return (
        <>
            <div className="relative w-full p-6 bg-white border border-gray-200 rounded-lg shadow dark:bg-gray-800 dark:border-gray-700 font-quickSand">
                <a href="#">
                    <h5 className="mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white">
                        Agregar Instituciones
                    </h5>
                </a>
                <a
                    className="inline-flex items-center px-3 py-2 text-sm font-medium text-center text-white bg-blue-700 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800 cursor-pointer"
                    onClick={() => handleOpenConfig(1)}
                >
                    Añadir
                    <svg
                        className="rtl:rotate-180 w-3.5 h-3.5 ms-2"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 14 10"
                    >
                        <path
                            stroke="currentColor"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth="2"
                            d="M1 5h12m0 0L9 1m4 4L9 9"
                        />
                    </svg>
                </a>
                {/* <MdOutlineSettingsApplications
                    className="absolute top-4 right-4 text-gray-700 dark:text-gray-300 cursor-pointer spin-hover"
                    size={24}

                /> */}
            </div>

            {openConfigPrimeraFase ? (
                <ModalConfigPrimeraFase
                    open={openConfigPrimeraFase}
                    setOpen={setOpenConfigPrimeraFase}
                    tipoFase={1}
                />
            ) : null}
        </>
    );
}

export default CardFaseIndividual